import React, { Component } from 'react';

import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';

import { getFolderRef, getFolderIndexRef } from '../../../../config/firebase';
import { getAllItems, updateLastUpdatedTimestamp } from '../../../../utils';

import Loader from '../../../../components/Loader';
import FolderListItem from '../FolderListItem';
import CSSListItemTransition from '../CSSListItemTransition';

const SortableItem = SortableElement(({folder, folderList}) => {
  return (
    <FolderListItem folder={folder} screen={folderList.props.screen} conformDelete={(folder) => folderList.conformDelete(folder)}/>
  );
});

const SortableList = SortableContainer(({folders, folderList}) => {
  return (
    <List>
      <CSSListItemTransition>
        {folders.map((folder, index) => {
          return (
            <SortableItem key={`item-${index}`} index={index} folder={folder} folderList={folderList} />
          );
        })}
      </CSSListItemTransition>
    </List>
  );
});

class FoldersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folders: null,
      adding: false,
      deleting: {},
      newFolderTitle: '',
      isDialogOpen: false,
    }

    this.foldersRef = getFolderIndexRef();

    this.handleTextfieldChange = this.handleTextfieldChange.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
    this.conformDelete = this.conformDelete.bind(this)
    this.handleDialogClose = this.handleDialogClose.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.onSortEnd = this.onSortEnd.bind(this)
  }

  componentDidMount() {
    getAllItems(this.foldersRef, (fldrs) => {
      const folders = fldrs.filter(folder => folder.screen === this.props.screen);

      if (folders.length > 0) {
        this.setState({ folders });
      } else {
        this.setState({ folders: 'no-folders' });
      }
    });
  }

  componentWillUnmount() {
    this.foldersRef.off();
  }

  handleTextfieldChange(event) {
    let newFolderTitle = event.target.value;
    this.setState({newFolderTitle});
  }

  handleAdd() {
    let title = this.state.newFolderTitle.trim();
    if (!title) {
      return;
    }

    let newFolderRef = getFolderIndexRef().push();
    newFolderRef.set({ title, screen: this.props.screen }, () => {
      this.setState({
        newFolderTitle: '',
        adding: false
      });
    });
    this.setState({adding: true});
  }

  conformDelete(folder) {
    this.setState({
      deleting: folder,
      isDialogOpen: true,
    });
  }

  handleDelete() {
    getFolderRef(this.state.deleting.id).remove().then(() => {
      updateLastUpdatedTimestamp();
      this.setState({
        deleting: {},
        isDialogOpen: false
      });
    });
  }

  handleDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    let {folders} = this.state;
    folders = arrayMove(folders, oldIndex, newIndex)
    // save new order in database
    folders.forEach((folder, index) => {
      getFolderRef(folder.id, this.props.visibility).child('order').set(index)
    });
    updateLastUpdatedTimestamp();
    this.setState({folders});
  };

  render() {
    if ( !this.state.folders ) {
      return (
        <Loader />
      )
    }

    let list;

    if ( this.state.folders === 'no-folders' ) {
      list = <p><br/> No folders to show!</p>
    } else {
      list = <SortableList folders={this.state.folders} onSortEnd={this.onSortEnd} useDragHandle={true} folderList={this} />;
    }

    return (
      <div className="list-wrapper">
        <div className="add-folder-wrapper">
          <TextField
            label="Add new folder"
            name="title"
            value={this.state.newFolderTitle}
            onChange={this.handleTextfieldChange}
            />
          <Button variant="raised" color="primary" onClick={this.handleAdd}>Add</Button>
        </div>
        {list}
        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="delete-folder-dialog-title"
          aria-describedby="delete-folder-dialog-description"
        >
          <DialogTitle id="delete-folder-dialog-title">{"Delete folder?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-folder-dialog-description">
              Are you sure you want to delete <strong>{this.state.deleting.title}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDelete} color="secondary">Delete</Button>
            <Button onClick={this.handleDialogClose} autoFocus>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default FoldersList;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/FoldersList/index.js